import { createTheme, Stack, ThemeProvider, useTheme } from '@mui/material';
import { forwardRef, PropsWithChildren, useMemo } from 'react';
import { FormProvider, UseFormReturn } from 'react-hook-form';
import RHFDebugger from './RHFDebugger';

type Props = UseFormReturn<any> & {
  onSubmit: (data: any) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLFormElement>) => void;
  enableDebugger?: boolean;
};

// Merge local overrides with the active Mercedes-Benz theme
const useMergedTheme = () => {
  const parent = useTheme();
  return useMemo(
    () =>
      createTheme(parent, {
        components: {
          MuiFormLabel: {
            styleOverrides: {
              asterisk: { color: parent.palette.error.main },
            },
          },
        },
      }),
    [parent]
  );
};

const RHFForm = forwardRef<HTMLFormElement, PropsWithChildren<Props>>(
  (
    { onSubmit, onKeyDown, children, enableDebugger = false, ...methods },
    ref
  ) => {
    const mergedTheme = useMergedTheme();
    return (
      <ThemeProvider theme={mergedTheme}>
        <FormProvider {...methods}>
          <Stack spacing={2} direction='row' alignItems='flex-start'>
            <form
              ref={ref}
              noValidate
              onSubmit={methods.handleSubmit(onSubmit, () => undefined)}
              onKeyDown={onKeyDown}
              style={{ width: '100%' }}
            >
              {children}
            </form>
            {enableDebugger && <RHFDebugger />}
          </Stack>
        </FormProvider>
      </ThemeProvider>
    );
  }
);

export default RHFForm;
